import React, { useState, useEffect, Fragment } from 'react';
import { toast } from "react-toastify";
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import LoadingOverlay from '../../components/loading/loading';
import service from '../../services/service';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import { IMAGE_PATH } from '../../config';

const EventsSlider = ({ data }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const intervalTime = 5000; // Auto-slide every 5 seconds

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex(prevIndex => (prevIndex + 1) % data.length);
        }, intervalTime);

        return () => clearInterval(interval);
    }, [data.length]);

    const handleNext = () => {
        setActiveIndex(prevIndex => (prevIndex + 1) % data.length);
    };

    const handlePrev = () => {
        setActiveIndex(prevIndex => (prevIndex - 1 + data.length) % data.length);
    };

    return (
        <div id="eventsCarousel" className="carousel slide">
            <div className="carousel-inner">
                {data.map((event, index) => (
                    <div
                        key={event._id}
                        className={`carousel-item ${index === activeIndex ? 'active' : ''}`}
                    >
                        <div className="row">
                            <div className="col-md-8">
                                <img
                                    src={event.images ? IMAGE_PATH + event.images : IMAGE_PATH + "/uploads/assets/EventImages/unavailable-image.jpg"}
                                    className="d-block w-100 rounded shadow"
                                    alt={event.title}
                                    style={{ height: '400px', objectFit: 'cover' }}
                                />
                            </div>
                            <div className="col-md-4 d-flex align-items-center">
                                <div className="p-4">
                                    <h2 className="mb-3 text-primary">{event.title}</h2>
                                    <p className="mb-4">{event.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Navigation Arrows */}
            <button
                className="carousel-control-prev"
                type="button"
                onClick={handlePrev}
            >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>

            <button
                className="carousel-control-next"
                type="button"
                onClick={handleNext}
            >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>

            {/* Navigation Dots */}
            <div className="carousel-indicators position-relative mt-4">
                {data.map((_, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`dot ${activeIndex === index ? 'active' : ''}`}
                        onClick={() => setActiveIndex(index)}
                    />
                ))}
            </div>
        </div>
    );
};

const Events = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getEventsForSlider();
    }, []);

    const getEventsForSlider = async () => {
        try {
            setLoading(true);
            const response = await service.view("events/slider");

            if (response && !response.success) {
                toast.error(response.message);
                return;
            }
            setData(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={'Events and Offers'} pagesub={'Events and Offers'} />
            <div className="wpo-about-area section-padding">
                {loading && <LoadingOverlay />}
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="wpo-about-text">
                                <div className="wpo-section-title">
                                    <span>Events</span>
                                </div>
                                {data.length > 0 ? (
                                    <EventsSlider data={data} />
                                ) : (
                                    <p className="text-center text-muted">No upcoming events available.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default Events;
